import { coursesListWatcherSaga } from './list.saga'
import { newCourseWatcherSaga } from './create.saga'
import { editCourseWatcherSaga } from './edit.saga'
import { getCourseWatcherSaga } from './get.saga'
import { myCoursesListWatcherSaga } from './mylist.saga'
import { allCoursesListWatcherSaga } from './allcourses.saga'
import { courseProgressWatcherSaga } from './courseprogress.saga'
import { mandatoryCoursesListWatcherSaga } from './mandatory-list.saga'
import { destroyCourseWatcherSaga } from './destroy.saga'
import { publishCourseWatcherSaga } from './publish.saga'
import { coursesDownloadWatcherSaga } from './download.saga'
import { coursesIndividualDownloadWatcherSaga } from './IndividualDownload.saga'
import { getCourseDataToDuplicateWatcherSaga } from './getToDuplicate.saga'
import { duplicateCourseWatcherSaga } from './duplicate.saga'
import { getAdminCourseWatcherSaga } from './getAdminCourse.saga'
import { courseNamesListWatcherSaga } from './allcourseNamesList.saga'
import { coursegetCountersWatcherSaga } from './getCounters.saga'
import { setNotificationEmailWatcherSaga } from './setNotificationEmail.saga'
import { getCourseFoldersListWatcherSaga } from './getCoursesFolders'
import { createRequestCourseWatcherSaga } from './createRequestCourse.saga'
import { editRequestCourseWatcherSaga } from './editRequestCourse.saga'
import { listRequestCoursesAdminWatcherSaga } from './listRequestCoursesAdmin.saga'
import { coursesDownloadDisabledUsersWatcherSaga } from './downloadDisabledUsers.saga'
import { coursesDownloadEvaluationsWatcherSaga } from './downloadEvaluations.saga'
import { getCourseAndCreateEnrolWatcherSaga } from './getCourseAndCreateEnrol.saga'
import { coursesUploadMassiveParticipantsWatcherSaga } from './uploadCourseParticipantsMassive.saga'

export const sagas = [
  coursesListWatcherSaga(),
  newCourseWatcherSaga(),
  editCourseWatcherSaga(),
  getCourseWatcherSaga(),
  myCoursesListWatcherSaga(),
  allCoursesListWatcherSaga(),
  courseProgressWatcherSaga(),
  mandatoryCoursesListWatcherSaga(),
  destroyCourseWatcherSaga(),
  publishCourseWatcherSaga(),
  coursesDownloadWatcherSaga(),
  coursesIndividualDownloadWatcherSaga(),
  getCourseDataToDuplicateWatcherSaga(),
  duplicateCourseWatcherSaga(),
  getAdminCourseWatcherSaga(),
  courseNamesListWatcherSaga(),
  coursegetCountersWatcherSaga(),
  setNotificationEmailWatcherSaga(),
  getCourseFoldersListWatcherSaga(),
  createRequestCourseWatcherSaga(),
  editRequestCourseWatcherSaga(),
  listRequestCoursesAdminWatcherSaga(),
  coursesDownloadDisabledUsersWatcherSaga(),
  coursesDownloadEvaluationsWatcherSaga(),
  getCourseAndCreateEnrolWatcherSaga(),
  coursesUploadMassiveParticipantsWatcherSaga(),
]

export default sagas
